import React from 'react'
import { kraviaOnboardStatus } from '@root/query'
import { useBusinessContext } from '@root/context'
import { AnimatedContentLoader } from '@root/components'
import { useQuery } from '@tanstack/react-query'
import { AnimatePresence } from 'framer-motion'
import { StartSlide } from '@root/pages/InvoicingPage/DebtCollection/trackerMessages/Onboarding/onboardingSlides/StartSlide'
import { SignatureSlide } from '@root/pages/InvoicingPage/DebtCollection/trackerMessages/Onboarding/onboardingSlides/SignatureSlide'

const InvoiceSettingDebtCollectionOnBoardKravia: React.FC = () => {
  const { slug } = useBusinessContext()
  const { data, isLoading } = useQuery({
    queryKey: [slug, 'kravia_onboard_status'],
    queryFn: () => kraviaOnboardStatus({ slug })
  })
  const showStart = data?.kravia_enabled === false
  const showWait = data?.kravia_verified === false && !showStart

  return (
    <AnimatedContentLoader isLoading={isLoading}>
      <AnimatePresence>
        {showStart && <StartSlide />}
        {showWait && <SignatureSlide />}
      </AnimatePresence>
    </AnimatedContentLoader>
  )
}

export default InvoiceSettingDebtCollectionOnBoardKravia
